import React, { useState, useEffect } from "react";
import {
    Box,
    Button,
    Typography,
    Modal,
    Backdrop,
    Fade,
    Grid,
    IconButton,
    CircularProgress,
    TextField,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    useMediaQuery,
    Tooltip,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { toast, ToastContainer } from "react-toastify";
import SearchIcon from "@mui/icons-material/Search";
import InputAdornment from "@mui/material/InputAdornment";
import "react-toastify/dist/ReactToastify.css";
import { CreateItem, getAllItemListByOrgId, updateItemDetails, deleteItemDetails, validatePassword } from "../services/api";
import { useUser } from "../context/UserContext";
import { Visibility, VisibilityOff } from '@mui/icons-material';
import BulkUpdateModal from '../components/BulkItemsUpdates'
import SpinnerLoading from "../utility/LoadingIndicator"




import { useTheme } from "@mui/material/styles";

const CreateItems = () => {
    const { user } = useUser();

    const [itemData, setItemData] = useState({
        orgId: user.orgId,
        itemId: "",
        itemsName: "",
        itemsUnits: "",
        issuePrice: "",
        mrp: "",
        barCode: "",
    });

    const [errors, setErrors] = useState({});
    const [itemErrors, setItemErrors] = useState({});
    const [openModal, setOpenModal] = useState(false);
    const [isSubmittingItem, setIsSubmittingItem] = useState(false);
    const [itemsList, setItemsList] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const isLargeDevice = useMediaQuery(theme.breakpoints.up("lg")); // For large devices
    const isExtraLargeDevice = useMediaQuery(theme.breakpoints.up("xl"));
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [open, setOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [loading, setLoading] = useState(true);
    const [password, setPassword] = useState("");
    const [passwordDialogOpen, setPasswordDailogOpen] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);


    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };


    const getAllItemsByUserOrgId = async (orgId) => {
        try {
            const response = await getAllItemListByOrgId(orgId);
            if (response?.status === 200) {

                setItemsList(response.data);
                console.log("Brands details : ", response.data);
            } else {
                setItemsList([]);
                console.log("Brands Details : ", response.data);
            }
        } catch (error) {
            console.error("Failed to fetch bills:", error);
            setItemsList([]);
        }
        finally {
            setLoading(false);
        }
    };

    const handleUpdateClick = (item) => {
        setSelectedItem(item);
        setIsModalOpen(true);
    };

    // Open password verification dialog
    const handleDeleteClick = (item) => {
        setSelectedItem(item);
        setPasswordDailogOpen(true);
    };

    // Close dialog
    const handleClose = () => {
        setOpen(false);
        setSelectedItem(null);
    };

    // Confirm delete
    const handleConfirmDelete = () => {
        if (selectedItem) {
            deleteItem(selectedItem);
        }
        handleClose();
    };

    const deleteItem = async (item) => {
        const itemsName = item.itemsName;
        const itemsUnits = item.itemsUnits;
        const itemId = item.itemId;
        const orgId = user.orgId;
        try {
            // Make the DELETE request
            const response = await deleteItemDetails(
                itemsName, itemsUnits, itemId, orgId
            );

            // Handle success response
            if (response.status === 200) {
                toast.success('Item and related records deleted successfully!');
                getAllItemsByUserOrgId(user.orgId);
                console.log('Response:', response.data);
                return response.data;
            }
        } catch (error) {
            // Handle error response
            console.error('Error deleting item:', error.response?.data || error.message);
            toast.error('Failed to delete the item. Please try again.');
            throw error;
        }

    };
    const handleCloseUpdateModal = () => {
        setIsModalOpen(false);
        setSelectedItem(null);
    };

    const handleSaveChanges = async () => {
        console.log(selectedItem);

        // Call the update method with the modified item
        try {
            const response = await updateItemDetails(
                selectedItem.itemsName,
                selectedItem.itemsUnits,
                selectedItem.issuePrice,
                selectedItem.mrp,
                selectedItem.itemId,
                user.orgId,
            );
            if (response.status === 200) {
                toast.success("Item Details Successfully Updated..!");
                getAllItemsByUserOrgId(user.orgId);
                handleCloseUpdateModal();
            }
            if (
                response.message ===
                "Please change at least one value to update the item."
            ) {
                toast.warn("Please change at least one value to update the item.");
            }
        } catch (error) {
            if (error.response && error.response.status === 400) {
                const errorMessage = error.response.data.message;
                toast.error(errorMessage);
            } else {

                toast.error("An error occurred while updating the item.");
            }
        }
        // handleCloseModal();
    };

    const handleItemChange = (e) => {
        const { name, value } = e.target;

        // Capitalize the first letter of every word if the name is 'itemsName'
        const formattedValue = name === "itemsName"
            ? value.replace(/\b\w/g, (char) => char.toUpperCase())
            : value;

        setItemData((prev) => ({ ...prev, [name]: formattedValue }));
        setItemErrors((prev) => ({ ...prev, [name]: "" }));
    };


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setSelectedItem((prev) => ({ ...prev, [name]: value }));
    };

    const validateItemForm = () => {
        let validationErrors = {};
        ["itemId", "itemsName", "itemsUnits", "issuePrice", "mrp"].forEach((field) => {
            if (!itemData[field]) validationErrors[field] = `${field} is required.`;
        });
        setItemErrors(validationErrors);
        return Object.keys(validationErrors).length === 0;
    };


    const handleItemSubmit = async (e) => {
        e.preventDefault();
        if (!validateItemForm()) return;

        setIsSubmittingItem(true);
        try {
            const response = await CreateItem(itemData);
            if (response.status === 201) {
                toast.success("Item created successfully!");
                setItemData({
                    orgId: user.orgId,
                    itemId: "",
                    itemsName: "",
                    itemsUnits: "",
                    issuePrice: "",
                    mrp: "",
                    barCode: "",
                });
                setOpenModal(false);
                getAllItemsByUserOrgId(user.orgId);
            }
        } catch (error) {
            toast.error(error.response?.data?.message || "Failed to create the item!");
        } finally {
            setIsSubmittingItem(false);
        }
    };

    const handleCloseModal = () => {
        setOpenModal(false);

        setErrors({});
        setItemErrors({});
    };


    const ItemsList = Array.isArray(itemsList)
        ? itemsList.filter((item) =>
            Object.values(item).some((value) =>
                value.toString().toLowerCase().includes(searchTerm.toLowerCase())
            )
        )
        : [];

    const handleSearch = (event) => {
        setSearchTerm(event.target.value);
    };

    const handleRest = () => {
        setItemData({
            orgId: user.orgId,
            itemId: "",
            itemsName: "",
            itemsUnits: "",
            issuePrice: "",
            mrp: "",
            barCode: "",
        });

    }

    useEffect(() => {
        getAllItemsByUserOrgId(user.orgId);
        setLoading(true)

    }, [user]);

    const handlePasswordVerify = async () => {
        try {
            console.log(user.userId);
            const response = await validatePassword(user.userId, password);
            if (response.status === 200) {

                setPasswordDailogOpen(false);
                setOpen(true);
                setPassword("");
            } else {
                toast.error("Password not verified. Please check password and try again.!");
            }
        } catch (error) {
            const errorMessage = error.response?.data?.message;

            if (errorMessage === "Invalid credentials.") {
                toast.error("Password not verified. Please check password and try again.");
            } else {
                toast.error(errorMessage || "User ID not found. Please enter correct UserID.");
            }
        }
    };

    return (
        <Box sx={{ textAlign: "center", pt: 1 }}>
            <ToastContainer />
            <Box sx={{ display: "flex", justifyContent: "space-between", alignContent: "center" }}>
                <Box >
                    <Typography sx={{ color: "#024CAA", fontSize: "30px", textAlign: "center" }}>
                        Brands List
                    </Typography>
                </Box>

                <Box>
                    <TextField
                        variant="outlined"
                        fullWidth
                        value={searchTerm}
                        onChange={handleSearch}
                        placeholder="Search by item name"
                        sx={{
                            input: { color: "#071952", padding: "6px" },
                            "& .MuiOutlinedInput-root": {
                                "& fieldset": { borderColor: "#071952" },
                                "&:hover fieldset": { borderColor: "#071952" },
                                "&.Mui-focused fieldset": { borderColor: "#3572EF" },

                            },
                            width: isMobile ? "100%" : "350px",
                        }}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <SearchIcon style={{ color: "#071952" }} />
                                </InputAdornment>
                            ),
                        }}
                    />
                </Box>


                <Box> 
                    <Button variant="contained" onClick={() => setModalVisible(true)} sx={{ marginRight: "10px", textTransform: "none", background: "#074799" }}>Bulk Update</Button>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            setOpenModal(true);
                        }}
                        sx={{ textTransform: "none" }}
                    >
                        Create Brand
                    </Button>
                </Box>

            </Box>

            <TableContainer component={Paper}
                sx={{
                    maxHeight: isExtraLargeDevice
                        ? 500 // Height for extra-large devices
                        : isLargeDevice
                            ? 420 // Height for large devices
                            : 370, // Default height for other devices
                    maxWidth: isExtraLargeDevice ? "100vw" : "none", // Max-width cap for XL
                    margin: isExtraLargeDevice ? "0 auto" : "inherit", // Center for XL
                    overflowY: "auto",
                    display: "flex",
                    flexDirection: "column",
                    textAlign: "center",

                    "&::-webkit-scrollbar": {
                        width: "6px",
                        height: "6px",
                    },
                    "&::-webkit-scrollbar-track": { backgroundColor: "#f1f1f1" },
                    "&::-webkit-scrollbar-thumb": {
                        backgroundColor: "#888",
                        borderRadius: "6px",
                    },
                    "&::-webkit-scrollbar-thumb:hover": { backgroundColor: "#555" },
                }}>
                <Table stickyHeader size={isMobile ? "small" : "medium"}>
                    <TableHead sx={{ color: "#071952" }}>
                        <TableRow>
                            <TableCell sx={{
                                textAlign: "center",
                                color: "white",
                                backgroundColor: "#133E87",
                                fontWeight: "550",
                                maxWidth: "250px",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                            }}><strong>Item ID</strong></TableCell>
                            <TableCell sx={{
                                textAlign: "center",
                                color: "white",
                                backgroundColor: "#133E87",
                                fontWeight: "550",
                                maxWidth: "250px",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                            }}><strong>Item Name</strong></TableCell>
                            <TableCell sx={{
                                textAlign: "center",
                                color: "white",
                                backgroundColor: "#133E87",
                                fontWeight: "550",
                                maxWidth: "250px",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                            }}><strong>Units</strong></TableCell>
                            <TableCell sx={{
                                textAlign: "center",
                                color: "white",
                                backgroundColor: "#133E87",
                                fontWeight: "550",
                                maxWidth: "250px",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                            }}><strong>Current Issue Price</strong></TableCell>
                            <TableCell sx={{
                                textAlign: "center",
                                color: "white",
                                backgroundColor: "#133E87",
                                fontWeight: "550",
                                maxWidth: "250px",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                            }}><strong>Old MRP's</strong></TableCell>
                            <TableCell sx={{
                                textAlign: "center",
                                color: "white",
                                backgroundColor: "#133E87",
                                fontWeight: "550",
                                maxWidth: "250px",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                            }}><strong> Current MRP</strong></TableCell>
                            <TableCell sx={{
                                textAlign: "center",
                                color: "white",
                                backgroundColor: "#133E87",
                                fontWeight: "550",
                                minWidth: "150px",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                            }}><strong>Actions</strong></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody >
                        {ItemsList.length > 0 ? (
                            ItemsList.reverse().slice().map((item) => (
                                <TableRow key={item._id} sx={{ textAlign: "center" }}>
                                    <TableCell sx={{ textAlign: "center" }}>{item.itemId}</TableCell>
                                    <TableCell sx={{ textAlign: "center" }}>{item.itemsName}</TableCell>
                                    <TableCell sx={{ textAlign: "center" }}>{item.itemsUnits}</TableCell>
                                    <TableCell sx={{ textAlign: "center" }}>₹ {item.issuePrice}</TableCell>
                                    <TableCell sx={{ textAlign: "center" }}>{item.oldMrps.length > 0 ? item.oldMrps.join("/-, ") : "No old MRP"}</TableCell>
                                    <TableCell sx={{ textAlign: "center" }}>₹ {item.mrp}</TableCell>
                                    <TableCell align="center">
                                        <Tooltip title="Edit">
                                            <IconButton onClick={() => handleUpdateClick(item)}>
                                                <EditIcon color="primary" />
                                            </IconButton>
                                        </Tooltip>
                                        <Tooltip title="Delete">
                                            <IconButton onClick={() => handleDeleteClick(item)}>
                                                <DeleteIcon color="error" />
                                            </IconButton>
                                        </Tooltip>
                                    </TableCell>
                                </TableRow>
                            ))
                        ) : loading ? (<TableRow>
                            <TableCell colSpan={7} align="center" sx={{ padding: 0, height: "60px" }}>
                                <Box
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    height="100%" // Spinner height inside table
                                >
                                    <SpinnerLoading color="primary" />
                                </Box>
                            </TableCell>
                        </TableRow>) : (
                            <TableRow>
                                <TableCell colSpan={7} align="center" sx={{ color: "#133E87" }}>
                                    No items found.
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
            {/* Verify Password Modal */}
            <Dialog
                open={passwordDialogOpen}
                onClose={() => setPasswordDailogOpen(false)}
                sx={{ borderRadius: "10px" }}
            >
                <DialogTitle style={{ color: "#006BFF" }}>Verify Password</DialogTitle>
                <DialogContent>
                    <TextField
                        sx={{ marginTop: "5px" }}
                        label="Password"
                        fullWidth
                        size="small"
                        type={showPassword ? "text" : "password"}
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton onClick={togglePasswordVisibility} edge="end">
                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            )
                        }}
                    />
                </DialogContent>
                <DialogActions sx={{ margin: "10px 14px 10px 0px " }}>
                    <Button variant="outlined" onClick={() => setPasswordDailogOpen(false)} sx={{ textTransform: "none" }}>Cancel</Button>
                    <Button variant="contained" onClick={handlePasswordVerify} color="primary" sx={{ textTransform: "none" }}>
                        Verify
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Confirmation Dialog */}
            <Dialog open={open} onClose={handleClose} sx={{
                '& .MuiDialog-paper': {
                    width: '400px', // Set the desired width
                    maxWidth: '90%', // Adjust for responsiveness
                    paddingBottom: '20px',
                    paddingRight: "20px", borderRadius: "8px"
                },
            }}>
                <DialogTitle sx={{ color: "#EB8317" }}>Confirm Delete</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to delete this item? This action cannot be
                        undone.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} variant="outlined" sx={{ textTransform: "none" }} >
                        Cancel
                    </Button>
                    <Button
                        onClick={handleConfirmDelete}
                        color="primary"
                        variant="contained"
                        sx={{ textTransform: "none" }}
                    >
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>

            {/*Bulk Uploads */}
            <BulkUpdateModal visible={modalVisible} getAllUpdatedBrands={getAllItemsByUserOrgId} onClose={() => {
                setModalVisible(false);

            }} />

            {/* Modal for Updating Item */}
            <Modal open={isModalOpen} onClose={handleCloseModal}>
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: 400,
                        bgcolor: "background.paper",
                        boxShadow: 24,
                        p: 4,
                        borderRadius: 2,
                    }}
                >
                    <h2 style={{ color: "#006BFF" }}>Update Item</h2>
                    {selectedItem && (
                        <Box>
                            <TextField
                                fullWidth
                                margin="normal"
                                label="Item Name"
                                name="itemsName"
                                value={selectedItem.itemsName}
                                onChange={handleInputChange}
                                disabled
                                size="small"
                            />
                            <TextField
                                fullWidth
                                margin="normal"
                                label="Units"
                                name="itemsUnits"
                                value={selectedItem.itemsUnits}
                                onChange={handleInputChange}
                                disabled
                                size="small"

                            />
                            <TextField
                                fullWidth
                                margin="normal"
                                label="Issue Price"
                                name="issuePrice"
                                value={selectedItem.issuePrice}
                                onChange={handleInputChange}
                                size="small"

                            />
                            <TextField
                                fullWidth
                                margin="normal"
                                label="MRP"
                                name="mrp"
                                value={selectedItem.mrp}
                                onChange={handleInputChange}
                                size="small"

                            />
                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    marginTop: 2,
                                    textTransform: "none"
                                }}
                            >

                                <Button variant="outlined" onClick={handleCloseUpdateModal} sx={{ marginRight: "10px", textTransform: "none" }}>
                                    Cancel
                                </Button>
                                <Button variant="contained" onClick={handleSaveChanges} sx={{ textTransform: "none" }}>
                                    Update
                                </Button>
                            </Box>
                        </Box>
                    )}
                </Box>
            </Modal>

            <Modal
                open={openModal}
                onClose={handleCloseModal}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Fade in={openModal}>
                    <Box
                        sx={{
                            maxWidth: 500,
                            mx: "auto",
                            mt: "10%",
                            p: 5,
                            bgcolor: "background.paper",
                            borderRadius: 2,
                            boxShadow: 3,
                            position: "relative",
                        }}
                    >
                        <IconButton
                            onClick={handleCloseModal}
                            sx={{ position: "absolute", top: 10, right: 8 }}
                        >
                            <CloseIcon />
                        </IconButton>
                        <>
                            <Typography variant="h6" gutterBottom style={{ color: "#006BFF" }}>
                                Create Item
                            </Typography>
                            <form onSubmit={handleItemSubmit}>
                                <Grid container spacing={2}>
                                    {["itemId", "itemsName", "itemsUnits", "issuePrice", "mrp", "barCode"].map((field) => (
                                        <Grid item xs={6} key={field}>
                                            <TextField
                                                label={field}
                                                fullWidth
                                                name={field}
                                                value={itemData[field]}
                                                onChange={handleItemChange}
                                                error={!!itemErrors[field]}
                                                helperText={itemErrors[field]}
                                                autoFocus={field === "barCode"}
                                                size="small"
                                            />
                                        </Grid>
                                    ))}
                                </Grid>
                                <Box sx={{ display: 'flex', justifyContent: "flex-end", alignItems: "center", textTransform: "none" }}>
                                    <Box><Button sx={{ background: "#ED3EF7", borderRadius: "5px", marginTop: "15px", marginRight: "10px", textTransform: "none", color: "white" }} onClick={handleRest}>Reset</Button></Box>
                                    <Box > <Button type="submit" sx={{ backgroundColor: "#006BFF", borderRadius: "5px", marginTop: "15px", textTransform: "none", color: "white" }} >{isSubmittingItem ? <CircularProgress size={24} color="inherit" /> : "Create Item"}</Button></Box>
                                </Box>
                            </form>
                        </>
                    </Box>
                </Fade>
            </Modal>
        </Box>
    );
};

export default CreateItems;


